export default "__VITE_ASSET__DRsZPq7Q__"